import styled from 'styled-components';

import { Column } from '../../../shared/styles';

const NameColumn = styled(Column)`
  width: 20%;
`;

const DataColumn = styled(Column)`
  width: 16%;
`;

export {
  DataColumn,
  NameColumn,
};
